import type { DocumentFromResponse } from '../../../documents/documents.types';

import * as rightPanelConstants from '../../rightPanel.constants';

import { useDocumentDetailsTabsAvailabilityData } from './useDocumentDetailsTabsAvailabilityData';

export const useDocumentDetailsTabsAvailability = ({
  documentId,
  areAnnotationsAvailable,
  areObligationsAvailable,
  canUserAccessDocument,
  isDiffAvailable,
  isUserAuthenticated,
  documentHasVersions,
  documentHasDockets,
  areExpertConnectionsAvaliable
}: {
  documentId: DocumentFromResponse['id'] | null;
  areAnnotationsAvailable: boolean;
  areObligationsAvailable: boolean;
  canUserAccessDocument: boolean;
  isDiffAvailable: boolean;
  isUserAuthenticated: boolean;
  documentHasVersions: boolean;
  documentHasDockets: boolean;
  areExpertConnectionsAvaliable: boolean;
}): Record<rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY, boolean> => {
  const { reduxState, formattedData } = useDocumentDetailsTabsAvailabilityData({
    documentId
  });

  return {
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.DETAILS]: !reduxState.isDiffView,
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.DOCKET_TIMELINE]:
      !reduxState.isDiffView && documentHasDockets,
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.VERSIONS]:
      !reduxState.isDiffView && documentHasVersions,
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.EXPERT_CONNECTION]:
      !reduxState.isDiffView && reduxState.areThereAnyExperts && areExpertConnectionsAvaliable,
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.RELATED_DOCUMENTS]:
      !reduxState.isDiffView &&
      reduxState.isAuthenticated &&
      reduxState.areThereAnyRelatedDocuments,
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.AUTO_SUMMARY]:
      !reduxState.isDiffView &&
      isUserAuthenticated &&
      canUserAccessDocument &&
      reduxState.areThereAnySummaries,
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.TASKS]:
      !reduxState.isDiffView &&
      (formattedData.isPowerOrAuthenticatedUser || !reduxState.isAuthenticated) &&
      Boolean(documentId),
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.ANNOTATIONS]:
      !reduxState.isDiffView &&
      areAnnotationsAvailable &&
      reduxState.doesDocumentHasSentences &&
      formattedData.isPowerOrAuthenticatedUser &&
      canUserAccessDocument &&
      !reduxState.isMobile,
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.OBLIGATIONS]:
      !reduxState.isDiffView &&
      areObligationsAvailable &&
      reduxState.doesDocumentHasSentences &&
      formattedData.isPowerOrAuthenticatedUser &&
      canUserAccessDocument &&
      !reduxState.isMobile,
    [rightPanelConstants.DOCUMENT_DETAILS_TAB_KEY.DIFF]:
      reduxState.isDiffView && isDiffAvailable && canUserAccessDocument
  };
};
